import {
   angularJsIcon,
   closeLockIcon,
   cssIcon,
   jQueryIcon,
   javaScriptIcon,
   mySqlIcon,
   openLockIcon,
   reactIcon,
   slide_AngularJSIcon,
   slide_JQueryIcon,
   slide_ReactIcon,
   slide_htaccessIcon,
   slide_jsIcon,
   toolsIcon1,
   toolsIcon2,
   toolsIcon3,
   toolsIcon4,
   toolsIcon5,
   toolsIcon6,
   wordPressIcon,
} from './iconFolder/icon';
import {
   blenderImg,
   co_workers_image1,
   co_workers_image10,
   co_workers_image11,
   co_workers_image12,
   co_workers_image13,
   co_workers_image14,
   co_workers_image15,
   co_workers_image2,
   co_workers_image3,
   co_workers_image4,
   co_workers_image5,
   co_workers_image6,
   co_workers_image7,
   co_workers_image8,
   co_workers_image9,
   gamesPagesServicesImgSubstance,
   gamesPagesServicesImgUnity,
   gimpImg,
   javaImg,
   laravelImg,
   makeHumanImg,
   materialImg,
   mobailAppDevelopend_services_android,
   mobailAppDevelopend_services_apis,
   mobailAppDevelopend_services_dataBases,
   mobailAppDevelopend_services_design,
   mobailAppDevelopend_services_j_query,
   mobailAppDevelopend_services_java,
   mobailAppDevelopend_services_python,
   mobailAppDevelopend_services_swift,
   nodejsImg,
   our_teemImage,
   proj1,
   proj2,
   proj3,
   projectImg_1,
   projectImg_2,
   projectImg_3,
   projectImg_4,
   projectImg_5,
   projectImg_6,
   projectImg_7,
   projectImg_8,
   pz3Img2,
   pz3Img3,
   reactImg,
   servicesLine_1,
   servicesLine_2,
   servicesLine_3,
   servicesLine_4,
   servicesLine_5,
   servicesLine_6,
   servicesLine_7,
   servicesLine_8,
   slideItemImg,
   turnsileImg1,
   turnsileImg10,
   turnsileImg11,
   turnsileImg12,
   turnsileImg13,
   turnsileImg14,
   turnsileImg15,
   turnsileImg16,
   turnsileImg17,
   turnsileImg18,
   turnsileImg19,
   turnsileImg2,
   turnsileImg20,
   turnsileImg21_PAC_S1Img1,
   turnsileImg21_PAC_S1Img2,
   turnsileImg21_PAC_S1Img3,
   turnsileImg22_TM_11Img1,
   turnsileImg22_TM_11Img2,
   turnsileImg3,
   turnsileImg4,
   turnsileImg5,
   turnsileImg6,
   turnsileImg7,
   turnsileImg8,
   turnsileImg9,
   webProject_services_ajax,
   webProject_services_bootstrap,
   webProject_services_css,
   webProject_services_html,
   webProject_services_javascript,
   webProject_services_jquery,
   webProject_services_laravel,
   webProject_services_mysql,
   webProject_services_nodejs,
   webProject_services_php,
   webProject_services_pyton,
   webProject_services_react,
} from '../src/images/images';

import {
   html_icon,
   css_icon,
   js_icon,
   butstrap_icon,
   nodJs_icon,
   jQuery_icon,
   ecmaScript_icon,
   reactRedux_icon,
   php_icon ,
   Laravel_icon,
   wordpres,
   loginWitFb_icon,
   htacces,
   oopMvc,
   rebux,
   githab,
   mongoDb,
   mysql,
   server

 } from '../src/iconFolder/icon';

// ===================tools-Info====================================

export const years_webex = new Date().getFullYear() - 2007;

export const packageTools = [
   {
      _id: '2',
      count: '5000+',
   },

   {
      _id: '3',
      count: '1900+',
   },
];

export const toolsData = [
   {
      icon: toolsIcon1,
      color: '#6C98EC',
   },

   {
      icon: toolsIcon2,
      color: '#7A77A3',
      type: 'students',
   },

   {
      icon: toolsIcon3,
      color: '#315A93',
      type: 'projects',
   },

   {
      icon: toolsIcon4,
      color: '#5073A7',
   },
   {
      icon: toolsIcon5,
      color: '#7A77A3',
   },

   {
      icon: toolsIcon6,
      color: '#315A93',
   },
];

// =====================our-Advantages=============================

export const ourAdvantagesData = [
   { _id: '1', color: '#383CA2CC', botomDivColor: '#383CA2' },

   { _id: '2', color: '#4E3584CC', botomDivColor: '#4E3584' },

   { _id: '3', color: '#383CA2CC', botomDivColor: '#383CA2' },

   { _id: '4', color: '#4E3584CC', botomDivColor: '#4E3584' },

   { _id: '5', color: '#383CA2CC', botomDivColor: '#383CA2' },

   { _id: '6', color: '#4E3584CC', botomDivColor: '#4E3584' },

   { _id: '7', color: '#383CA2CC', botomDivColor: '#383CA2' },

   { _id: '8', color: '#4E3584CC', botomDivColor: '#4E3584' },

   { _id: '9', color: '#383CA2CC', botomDivColor: '#383CA2' },

   { _id: '10', color: '#4E3584CC', botomDivColor: '#4E3584' },

   { _id: '11', color: '#383CA2CC', botomDivColor: '#383CA2' },
];

// ===================services==============================

export const servicesData = [
   {
      _id: '1',
      servicesLine: servicesLine_1,
      color: '#2B72C7',
   },

   {
      _id: '2',
      servicesLine: servicesLine_2,
      color: '#5A3D99',
   },

   {
      _id: '3',
      servicesLine: servicesLine_3,
      color: '#5DA0CB',
   },

   {
      _id: '4',
      servicesLine: servicesLine_4,
      color: '#3936B6',
   },

   {
      _id: '5',
      servicesLine: servicesLine_5,
      color: '#2768B5',
   },

   {
      _id: '6',
      servicesLine: servicesLine_6,
      color: '#5B3D9A',
   },

   {
      _id: '7',
      servicesLine: servicesLine_7,
      color: '#5EA1CC',
   },

   {
      _id: '8',
      servicesLine: servicesLine_8,
      color: '#3B38BC',
   },
];

// ===============================createWebAndMobileApp==============================================================

export const createWebAndMobileApp_data = [
   {
      _id: '1',
      title: 'Վեբ ծրագրի պատրաստում',
      txt: 'Կայքերի ստեղծում զրոյից- դա վեբ ռեսուրս է, որը Webex Technologies ընկերությունը պատրաստում է զրոյից՝ մասնակցելով դրա ստեղծման բոլոր փուլերին։Այլ կերպ ասած, հաճախորդը բարձրաձայնում է իր նպատակները, ցանկությունները դիզայնի և ինտերֆեյսի մասին և մենք դրանց հիման վրա ձևավորում ենք վաճառող կայք։',
   },

   {
      _id: '2',
      title: 'Բջջային հավելվածներ',
      txt: 'IOS-ի եվ Android-ի համար բջջային հավելվածների հուսալի ստեղծում -“Webex Technologies”- ը բջջային հավելվածների ստեղծման Հայաստանյան ընկերություն է, ունի բազմաթիվ տարիների փորձ բջջային ոլորտի տեխնոլոգիաների և հարթակների հետ։Մենք առաջարկում ենք բջջային հավելվածների զարգացման ծառայությունների լայն շրջանակ Հայաստանի և այլ երկրների շուկայում։Մեր ընկերությունը տրամադրում է ՏՏ խորհրդատվություն, մշակում,նախագծում, փորձարկում և արտադրանքի տեխնիկական աջակցություն։',
   },

   {
      _id: '3',
      title: 'Խաղերի եւ Unity-ի ստեղծում',
      txt: '“Webex Technologies” ընկերության կողմից Unity ծրագրով ստեղծված հավելվածների առավելությունները-Մեր ընկերությունը հանդիսանում է փորձառու և հուսալի գործընկեր Unity-ի միջոցով լուծումներ մշակելու գործում։Մենք տարիների ընթացքում ամբողջ աշխարհում հաճախորդների համար արդյունավետ և վստահելի ծրագրեր ենք ստեղծում։Unity տեխնոլոգիաները օգտագործելով՝ մենք հաջողությամբ լուծում ենք խնդիրներ այնպիսի ոլորտում, ինչպիսիք են օնլայն առևտրի, խաղերի, առողջապահության, կրթության, գովազդի և այլն։Եթե ցանկանում եք քննարկել նախագծի մանրամասները,խնդրում ենք կապնվել մեզ հետ։',
   },

   {
      _id: '4',
      title: '3D մոդելավորում',
      txt: 'Եռաչափ մոդելավորում կամ 3D մոդելավորում- ցանկացած առարկաների կամ օբյեկտների եռաչափ պատկերների ստեղծումն է։Այս նպատակով մասնագետները օգտագործում են հատուկ համակարգչային ծրագրեր, այսպես կոչված 3D ծրագրեր։Նրանց օգնությամբ երկրաչափական նախագծերը կառուցված են հարթության վրա, որոնք անհրաժեշտ են եռաչափ պատկեր ստեղծելու համար։ 3D մոդելավորման գրավչությունը կայանում է տեխնոլոգիայի գրեթե անսահմանափակ հնարավորությունների մեջ։Օգտագործելով 3D գրաֆիկա՝ դուք կարող եք ստեղծել ցանկացած իրական կամ երևակայական շենքի, ստատիկ օբյեկտի կամ երևույթի մոդել։',
   },

   {
      _id: '5',
      title: 'CRM սիստեմի պատրաստում',
      txt: 'CRM համակարգի մշակումն ու ներդնումը - առավել պահանջարկ ունի այն իրավիճակներում, երբ տեղի է ունենում բիզնեսի և ընկերության կառավարման որակական թռիչք։Այսինքն՝ օրվա ընթացքում հաղորդակցությունների(վաճառքի, գործարքների), ինչպես նաև գործարար կապերի քանակը(հեռախոսազանգեր, էլ- նամակներ,SMS ծանուցումներ), որոնք կառավարիչը կատարում է մեկ ամսվա ընթացքում, գերազանցում է մարդուն հասանելի օպերատիվ հիշողության շեմը, այս դեպքում ռեսուրսները, որը անձնակազմ է ծախսում փաստաթղթերի և Excel աղյուսակների վրա։CRM համակարգին կարող են փոխանցել տվյալ գործառույթները՝ 1․ Պաատվերի կատարման և գործարքների կնքման ավտոմատացում յուրաքանչյուր կոնկրետ դիրքի կարգավիճակը հետևելու միջոցով․ 2․ Փաստաթղթաշրջանառության պարզեցում՝ պայմանավորված պայմանագրերի, ակտերի, հաշիվների և հաշիվ ապրանքագրերի ավտոմատ ստեղծմամբ, 3․ Հաճախորդների միասնական բազայի վարում, որը պարունակում է մանրամասն տեղեկատվություն յուրաքանչյուր հաճախորդի և նրա հետ փոխազդեցությունների պատմության մասին․ ERP համակարգերի մշակում և ներդրում։',
   },

   {
      _id: '6',
      title: 'CRM սիստեմի պատրաստում',
      txt: 'CRM համակարգի մշակումն ու ներդնումը - առավել պահանջարկ ունի այն իրավիճակներում, երբ տեղի է ունենում բիզնեսի և ընկերության կառավարման որակական թռիչք։Այսինքն՝ օրվա ընթացքում հաղորդակցությունների(վաճառքի, գործարքների), ինչպես նաև գործարար կապերի քանակը(հեռախոսազանգեր, էլ- նամակներ,SMS ծանուցումներ), որոնք կառավարիչը կատարում է մեկ ամսվա ընթացքում, գերազանցում է մարդուն հասանելի օպերատիվ հիշողության շեմը, այս դեպքում ռեսուրսները, որը անձնակազմ է ծախսում փաստաթղթերի և Excel աղյուսակների վրա։CRM համակարգին կարող են փոխանցել տվյալ գործառույթները՝ 1․ Պաատվերի կատարման և գործարքների կնքման ավտոմատացում յուրաքանչյուր կոնկրետ դիրքի կարգավիճակը հետևելու միջոցով․ 2․ Փաստաթղթաշրջանառության պարզեցում՝ պայմանավորված պայմանագրերի, ակտերի, հաշիվների և հաշիվ ապրանքագրերի ավտոմատ ստեղծմամբ, 3․ Հաճախորդների միասնական բազայի վարում, որը պարունակում է մանրամասն տեղեկատվություն յուրաքանչյուր հաճախորդի և նրա հետ փոխազդեցությունների պատմության մասին․ ERP համակարգերի մշակում և ներդրում։',
   },
];

// =========================================VideoCoursesSection========================================================

// export const packageTxts = {
//    free_package: {
//       txt: 'Կայքում ներկայացված են վիդեոդասեր, որոնք կարող եք դիտել բացարձակ անվճար։ Կծանոթանաք դասավանդման ձևերին, և կհամոզվեք, որ մեր վիդեոդասերը պարզ են և հասկանալի բոլորի համար։',
//       icon: openLockIcon,
//       _id: '1',
//    },
//    standart_package: {
//       txt: 'Բազային գիտելիքներ, որոոնք կօգնեն Ձեզ տիրապետելու այն ծրագրավորման լեզուներին և մեթոդներին, որոնց օգնությամբ դուք կարող եք աշխատել Վեբ ծրագրավորման ոլորտում։',
//       icon: closeLockIcon,
//       _id: '2',
//    },
//    profesional_package: {
//       txt: 'Բազային գիտելիքներ, որոոնք կօգնեն Ձեզ տիրապետելու այն ծրագրավորման լեզուներին և մեթոդներին, որոնց օգնությամբ դուք կարող եք աշխատել եբ ծրագրավորման ոլորտում։',
//       icon: closeLockIcon,
//       _id: '3',
//    },
//    premium_package: {
//       txt: 'Բազային գիտելիքներ, որոոնք կօգնեն Ձեզ տիրապետելու այն ծրագրավորման լեզուներին և մեթոդներին, որոնց օգնությամբ դուք կարող եք աշխատել եբ ծրագրավորման ոլորտում։',
//       icon: closeLockIcon,
//       _id: '4',
//    },
// };
// export const VideoCoursesSectionData = [
//    {
//       title: 'Փորձնական դաս',
//       type: 'free_package',
//       timeLine: 'Տեվողությունը-120 Րոպե',
//       value: 'Արժեքը-0 Դրամ',
//    },

//    {
//       title: 'Ստանդարտ փաթեթներ',
//       type: 'standart_package',
//       timeLine: 'Տեվողությունը-960 Րոպե',
//       value: 'Արժեքը-45000 Դրամ',
//    },

//    {
//       title: 'Պրոֆեսիոնալ փաթեթներ',
//       type: 'profesional_package',
//       timeLine: 'Տեվողությունը-1440 Րոպե',
//       value: 'Արժեքը-60000 Դրամ',
//    },

//    {
//       title: 'Պրոֆեսիոնալ փաթեթներ',
//       type: 'premium_package',
//       timeLine: 'Տեվողությունը-1440 Րոպե',
//       value: 'Արժեքը-60000 Դրամ',
//    }
// ];


export const videoCoursesSectionData = [
   {
      id: '1',
      img: reactImg,
      name: 'React JS',
      price: '60000'
   },

   {
      id: '2',
      img: javaImg,
      name: 'Java',
      price: '120000'
   },
   {
      id: '3',
      img: laravelImg,
      name: 'Laravel',
      price: '80000'
   },
   {
      id: '4',
      img: nodejsImg,
      name: 'Node JS',
      price: '60000'
   },
   
]

// ============================slide=========================================

export const programingLengImg = slideItemImg;

export const slideData = [
   {
      _id: '1',
      title: 'htaccess',
      timeLine: 'Տեվողությունը 30 րոպե',
      icon: slide_htaccessIcon,
      txt: 'Սա անանուն կոնֆիգուրացիայի ֆայլ է Apache վեբ սերվերի համար՝ .htaccess ընդլայնմամբ։Այդ ֆայլի միջոցով մենք կառավարում ենք սերվերի աշխատանքը առանձին պապկաներում։',
      type: 'htaccess_package',
   },

   {
      _id: '2',
      title: 'JavaScript',
      timeLine: 'Տեվողությունը 235 րոպե',
      icon: slide_jsIcon,
      txt: 'Javascript -ը ծրագրավորման լեզու է, որի միջոցով էջին տրվում է ինտերակտիվություն։Նրա օգնությամբ ստեղծվում են ծրագրեր, որոնք ներառվում են HTML կոդում (login, password, registration և այլն)։',
      type: 'JavaScript_package',
   },

   {
      _id: '3',
      title: 'REACT',
      timeLine: 'Տեվողությունը 250 րոպե',
      icon: slide_ReactIcon,
      txt: 'REACT - արդյունավետ, ճկուն Javascript գրադարան է user ինտերֆեյս կառուցելու համար։Այն շատ արագ է աշխատում։ Մանրամասների մասին կխոսվի վիդեոդասերի ժամանակ։',
      type: 'REACT_package',
   },

   {
      _id: '4',
      title: 'JQuery',
      timeLine: 'Տեվողությունը 166 րոպե',
      icon: slide_JQueryIcon,
      txt: 'JQuery-Javascript-ի պատրաստի գրադարան է։Նրա օգնությամբ հեշտությամբ դիմում են DOM-ից ցանկացած էլեմենտին։JQuery գրադարանը ապահովում է հարմարավետ API-ը AJAX-ով աշխատելու համար։',
      type: 'JQuery_package',
   },

   {
      _id: '5',
      title: 'Angular Js',
      timeLine: 'Տեվողությունը 32 րոպե',
      icon: slide_AngularJSIcon,
      txt: 'Angular JS-ը JavaScript-ի Framework է։Այն նախատեսված է վեբ ծրագրեր կազմելու համար։AngularJS-ը գրադարան չէ։Այնունի մի շարք, որոնք հեշտացնում են ծրագրավորողի աշխատանքը։',
      type: 'AngularJs_package',
   },

   {
      _id: '6',
      title: 'Angular Js',
      timeLine: 'Տեվողությունը 32 րոպե',
      icon: slide_AngularJSIcon,
      txt: 'Angular JS-ը JavaScript-ի Framework է։Այն նախատեսված է վեբ ծրագրեր կազմելու համար։AngularJS-ը գրադարան չէ։Այնունի մի շարք, որոնք հեշտացնում են ծրագրավորողի աշխատանքը։',
      type: 'AngularJs_package',
   },

   {
      _id: '7',
      title: 'Angular Js',
      timeLine: 'Տեվողությունը 32 րոպե',
      icon: slide_AngularJSIcon,
      txt: 'Angular JS-ը JavaScript-ի Framework է։Այն նախատեսված է վեբ ծրագրեր կազմելու համար։AngularJS-ը գրադարան չէ։Այնունի մի շարք, որոնք հեշտացնում են ծրագրավորողի աշխատանքը։',
      type: 'AngularJs_package',
   },
];

export const responsive = {
   superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1440 },
      items: 4,
      slidesToSlide: 2,
   },
   desktop: {
      breakpoint: { max: 1440, min: 1024 },
      items: 3,
   },
   tablet: {
      breakpoint: { max: 1024, min: 720 },
      items: 2,
   },
   mobile: {
      breakpoint: { max: 510, min: 0 },
      items: 1,
   },
};

//   =======================================projectSection===============================================

export const projectSectionData = [
   {
      _id: '1',
      img: projectImg_1,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '2',
      img: projectImg_2,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '3',
      img: projectImg_3,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '4',
      img: projectImg_4,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '5',
      img: projectImg_5,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '6',
      img: projectImg_6,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '7',
      img: projectImg_7,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '8',
      img: projectImg_8,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '9',
      img: projectImg_8,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '10',
      img: projectImg_7,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '11',
      img: projectImg_8,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '12',
      img: projectImg_8,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },
   {
      _id: '13',
      img: projectImg_7,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '14',
      img: projectImg_8,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },

   {
      _id: '15',
      img: projectImg_8,
      txt: 'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. ',
   },
];

// ==================================coursesRegistration=================================================

export const coursesRegistrationSlideData = [
   {
      _id: '1',
      icon: javaScriptIcon,
      title: 'Java Script',
      countline: '255',
   },

   {
      _id: '2',
      icon: reactIcon,
      title: 'React',
      countline: '131',
   },

   {
      _id: '3',
      icon: jQueryIcon,
      title: 'JQuery',
      countline: '187',
   },

   {
      _id: '4',
      icon: angularJsIcon,
      title: 'Angular Js',
      countline: '310',
   },

   {
      _id: '5',
      icon: mySqlIcon,
      title: 'MySQL',
      countline: '254',
   },

   {
      _id: '6',
      icon: cssIcon,
      title: 'CSS/CSS3',
      countline: '174',
   },

   {
      _id: '7',
      icon: wordPressIcon,
      title: 'WordPress',
      countline: '256',
   },
];

export const coursesRegistrationInfoData = [
   {
      _id: '1',
      title: 'Ին՞չ է REACT-ը',
      txt: 'Հակառակ ընդհանուր պատկերացմանը` Lorem Ipsum-ը այդքան էլ պատահական հավաքված տեքստ չէ: Այս տեքստի արմատները հասնում են Ք.ա. 45թ. դասական լատինական գրականություն. այն 2000 տարեկան է:',
   },

   {
      _id: '2',
      title: 'Ին՞չ է նշանակում XML',
      txt: 'Հակառակ ընդհանուր պատկերացմանը` Lorem Ipsum-ը այդքան էլ պատահական հավաքված տեքստ չէ: Այս տեքստի արմատները հասնում են Ք.ա. 45թ. դասական լատինական գրականություն. այն 2000 տարեկան է:',
   },

   {
      _id: '3',
      title: 'Ին՞չ է նշանակում CDATA',
      txt: 'Հակառակ ընդհանուր պատկերացմանը` Lorem Ipsum-ը այդքան էլ պատահական հավաքված տեքստ չէ: Այս տեքստի արմատները հասնում են Ք.ա. 45թ. դասական լատինական գրականություն. այն 2000 տարեկան է:',
   },

   {
      _id: '4',
      title: 'Ին՞չ է XPath-ը',
      txt: 'Հակառակ ընդհանուր պատկերացմանը` Lorem Ipsum-ը այդքան էլ պատահական հավաքված տեքստ չէ: Այս տեքստի արմատները հասնում են Ք.ա. 45թ. դասական լատինական գրականություն. այն 2000 տարեկան է:',
   },
];

// =============================================================================

export const projectsPageData = [
   {
      _id: '1',
      img: projectImg_1,
      _img: projectImg_2,
      description: 'Նկարագրություն',
      txt: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
      nameTitle: 'Նախագծի անվանումը',
      name: 'Business Fox',
      lngTitle: 'Programing languages',
      lng: 'PHP,Laravel,ES9,jQuery,Ajax,WebScokets,MySQL',
      periodTitle: 'Creation period',
      period_month: '9 month',
      dateTitle: 'Date of creation',
      date: '2022',
      type: 'WebSite',
   },

   {
      _id: '2',
      img: projectImg_2,
      _img: projectImg_1,
      description: 'Նկարագրություն',
      txt: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
      nameTitle: 'Նախագծի անվանումը',
      name: 'Business Fox',
      lngTitle: 'Programing languages',
      lng: 'PHP,Laravel,ES9,jQuery,Ajax,WebScokets,MySQL',
      periodTitle: 'Creation period',
      period_month: '9 month',
      dateTitle: 'Date of creation',
      date: '2022',
      type: 'WebSite',
   },

   {
      _id: '3',
      img: projectImg_3,
      _img: projectImg_1,
      description: 'Նկարագրություն',
      txt: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
      nameTitle: 'Նախագծի անվանումը',
      name: 'Business Fox',
      lngTitle: 'Programing languages',
      lng: 'PHP,Laravel,ES9,jQuery,Ajax,WebScokets,MySQL',
      periodTitle: 'Creation period',
      period_month: '9 month',
      dateTitle: 'Date of creation',
      date: '2022',
      type: 'mobile',
   },

   {
      _id: '4',
      img: projectImg_4,
      _img: projectImg_3,
      description: 'Նկարագրություն',
      txt: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
      nameTitle: 'Նախագծի անվանումը',
      name: 'Business Fox',
      lngTitle: 'Programing languages',
      lng: 'PHP,Laravel,ES9,jQuery,Ajax,WebScokets,MySQL',
      periodTitle: 'Creation period',
      period_month: '9 month',
      dateTitle: 'Date of creation',
      date: '2022',
      type: '3d',
   },
];

export const co_workers_data = [
   {
      _id: '1',
      img: co_workers_image1,
      txt: 'ՀՀ Կրթության գիտության, մշակույթի եվ սպորտի նախարարություն',
   },

   {
      _id: '2',
      img: co_workers_image1,
      txt: 'ՀՀ տարածքային կառավարման եվ ենթակառուցվածքների նախարարություն',
   },

   {
      _id: '3',
      img: co_workers_image1,
      txt: 'ՀՀ բարձր տեխնոլոգիական արդյունաբերության նախարարություն',
   },

   {
      _id: '4',
      img: co_workers_image1,
      txt: 'ՀՀ տարածքային կառավարման եվ զարգացման միգրացիոն ծառայություն',
   },

   {
      _id: '5',
      img: co_workers_image2,
      txt: 'Վ․Ա․ Ֆանարջյանի անվան ուռուցքաբանության ազգային կենտրոն ՓԲԸ',
   },

   {
      _id: '6',
      img: co_workers_image1,
      txt: 'ՀՀ Հանրային ծառայությունները կարգավորող հանձնաժողով',
   },

   {
      _id: '7',
      img: co_workers_image1,
      txt: 'Գույքի գնահատման և աճուրդի կենտրոն',
   },

   {
      _id: '8',
      img: co_workers_image3,
      txt: 'ՀՀ Պաշտպանության նախարարություն',
   },

   {
      _id: '9',
      img: co_workers_image4,
      txt: 'ՈՒռուցքաբանության ազգային կենտրոն',
   },

   {
      _id: '10',
      img: co_workers_image5,
      txt: 'ԿԳՄՍՆ երիտասարդական կենտրոն',
   },

   {
      _id: '11',
      img: co_workers_image6,
      txt: 'Հեմոֆիլիայի և թրոմբոֆիլիայի հայկական կենտրոն',
   },

   {
      _id: '12',
      img: co_workers_image7,
      txt: 'Պրիզմա հետազոտության և վերլուծության կենտրոն',
   },

   {
      _id: '13',
      img: co_workers_image8,
      txt: 'Օրբելի վերլուծական - հետազոտական կենտրոն',
   },

   {
      _id: '14',
      img: co_workers_image9,
      txt: 'ՀՀ ոստիկանություն',
   },

   {
      _id: '15',
      img: co_workers_image10,
      txt: 'LGG foundation',
   },

   {
      _id: '16',
      img: co_workers_image11,
      txt: 'Էլնարտի ՍՊԸ',
   },
   {
      _id: '17',
      img: co_workers_image12,
      txt: 'Angel investor Club of Armenia',
   },

   {
      _id: '18',
      img: co_workers_image13,
      txt: 'Ներդրումների աջակցման կենտրոն',
   },

   {
      _id: '19',
      img: co_workers_image1,
      txt: 'Կադաստրի Կոմիտե',
   },

   {
      _id: '20',
      img: co_workers_image1,
      txt: 'Մասիսի համայնք',
   },

   {
      _id: '21',
      img: co_workers_image14,
      txt: 'Լիգա ուսլուգ ՍՊԸ',
   },
];

// =========Out teem=================================

export const ourt_teem_data = [
   {
      _id: '1',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
   {
      _id: '2',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
   {
      _id: '3',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
   {
      _id: '4',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
   {
      _id: '5',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
   {
      _id: '6',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
   {
      _id: '7',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
   {
      _id: '8',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
   {
      _id: '9',
      name: 'name surname',
      img: our_teemImage,
      stack: 'Front-end',
      experience: '5years',
   },
];

// ==================servicesPAge===========================

export const servicesPageItemsData = [
   {
      id: '1',
   },

   {
      id: '2',
   },
   {
      id: '3',
   },
   {
      id: '4',
   },
   {
      id: '5',
   },
   {
      id: '6',
   },
];

// ==============KeyWord-Component============================================

export const keyWordData = [
   {
      id: '1',
      path: '/website-promotion',
      txt: 'Комплексное продвижение сайтов,',
   },

   {
      id: '2',
      path: '/website-promotion',
      txt: 'Бюджетное продвижение,',
   },

   {
      id: '3',
      path: '/support',
      txt: 'Реклама в интернете,',
   },

   {
      id: '4',
      path: '/website-promotion',
      txt: 'Поисковое продвижение сайта,',
   },

   {
      id: '5',
      path: '/web-project',
      txt: 'Оптимизация сайта,',
   },

   {
      id: '6',
      path: '/website-promotion',
      txt: 'SEO - поисковая оптимизация,',
   },

   {
      id: '7',
      path: '/website-promotion',
      txt: 'Контекстная реклама,',
   },

   {
      id: '8',
      path: '/website-promotion',
      txt: 'Продвижение в соцсетях, блогах, сервиса,',
   },

   {
      id: '9',
      path: '/support',
      txt: ' Бесплатный экспресс-аудит сайта,',
   },

   {
      id: '10',
      path: '/web-project',
      txt: '  Бесплатная установка счетчика,',
   },

   {
      id: '11',
      path: '/website-promotion',
      txt: 'Продвижение и оптимизация сайтов: вопрос-ответ,',
   },

   {
      id: '12',
      path: '/website-promotion',
      txt: 'Статьи о продвижении сайтов,',
   },

   {
      id: '13',
      path: '/website-promotion',
      txt: 'Стоимость продвижения сайтов,',
   },

   {
      id: '14',
      path: '/web-project',
      txt: ' Создание бренд-страниц и групп в соцсетях,',
   },

   {
      id: '15',
      path: '/3d-modeling',
      txt: ' Трехмерное моделирование,',
   },

   {
      id: '16',
      path: '/3d-modeling',
      txt: ' Blender,',
   },

   {
      id: '17',
      path: '/3d-modeling',
      txt: ' Gimp,',
   },

   {
      id: '18',
      path: '/3d-modeling',
      txt: ' 3D Визуализация коттеджа с территорией,',
   },

   {
      id: '19',
      path: '/3d-modeling',
      txt: ' 3D моделирование,',
   },

   {
      id: '20',
      path: '/3d-modeling',
      txt: ' 3D Визуализация интерьеров,',
   },

   {
      id: '21',
      path: '/mobile',
      txt: 'ИТ-консалтинг,',
   },

   {
      id: '22',
      path: '/mobile',
      txt: 'iOS,',
   },

   {
      id: '23',
      path: '/mobile',
      txt: 'Android,',
   },

   {
      id: '24',
      path: '/mobile',
      txt: ' Дизайн,',
   },

   {
      id: '25',
      path: '/unity-games',
      txt: 'Unity разработкиа,',
   },

   {
      id: '26',
      path: '/unity-games',
      txt: 'UI/UX дизайн,',
   },

   {
      id: '27',
      path: '/unity-games',
      txt: '2D и 3D разработка игр',
   },
];

// ===============registerDrop======================

export const registerDropData = [
   {
      id: '1',
      title: 'HTML/HTML 5',
      txt: 'txt1',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:html_icon
      },

   {
      id: '2',
      title: 'CSS/CSS3',
      txt: 'txt2',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:css_icon
   },

   {
      id: '3',
      title: 'JavaScript',
      txt: 'txt3',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:js_icon
      },

   {
      id: '4',
      title: 'BootStrap',
      txt: 'txt4',
      text_p: 'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:butstrap_icon
      },
   {
      id: '5',
      title: 'Node JS',
      txt: 'txt5',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:nodJs_icon
      },
     

   {
      id: '6',
      title: 'jQuery',
      txt: 'txt6',
      text_p: 'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:jQuery_icon
      },
   {
      id: '7',
      title: 'ECMAScript(ES6)',
      txt: 'txt7',
      text_p: 'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:ecmaScript_icon
      },
   {
      id: '8',
      title: 'REACT/REDUX',
      txt: 'txt8',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:reactRedux_icon
      },
   {
      id: '9',
      title: 'PHP',
      txt: 'txt9',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:php_icon
      },
   {
      id: '10',
      title: 'Laravel',
      txt: 'txt10',
      text_p: 'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:Laravel_icon
      },
   {
      id: '11',
      title: 'Wordpress',
      txt: 'txt11',
      text_p: 'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:wordpres
      },
   {
      id: '12',
      title: 'Login With FB',
      txt: 'txt12',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:loginWitFb_icon
      },
   {
      id: '13',
      title: '.htaccess',
      txt: 'txt13',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:htacces
      },
   {
      id: '14',
      title: 'OOP/MVC',
      txt: 'txt14',
      text_p: 'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:oopMvc
      },
   {
      id: '15',
      title: 'Rebux',
      txt: 'txt15',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:rebux
      },
   {
      id: '16',
      title: 'GitHub',
      txt: 'txt16',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:githab
      },
   {
      id: '17',
      title: 'mongo db ',
      txt: 'txt17',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:mongoDb
      },
   {
      id: '18',
      title: 'MySQL',
      txt: 'txt18',
      text_p: 'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:mysql
      },
   {
      id: '19',
      title: 'Server',
      txt: 'txt19',
      text_p:'HTML (Hypertext Markup Language) այն ծածկագիրն է, որն օգտագործվում է վեբ էջի և դրա բովանդակության կառուցվածքի և ցուցադրման համար:',
      icon:server
      },
];



export const privateProjectsData = [
   {
      id: '1',
      img: proj1,
      path: 'https://event.webex.am/'
   },

   {
      id: '2',
      img: proj2,
      path: 'https://goreyansgarden.webex.am/'
   },

   {
      id: '3',
      img: proj3,
      path: ''
   },


]






export const responsive3 = {
   superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1440 },
      items: 3,
      slidesToSlide: 2,
   },
   desktop: {
      breakpoint: { max: 1440, min: 1024 },
      items: 2,
   },
   tablet: {
      breakpoint: { max: 1024, min: 720 },
      items: 2,
   },
   mobile: {
      breakpoint: { max: 510, min: 0 },
      items: 1,
   },
};



// ======================turnstile==========================


export const turnstileData = [,

   {
      id: '22',
      img: [turnsileImg22_TM_11Img1, turnsileImg22_TM_11Img2],
      code: 'TM-11',
      price1: '490.000',
      price2: '784.000',
   },

   {
      id: '21',
      img: [turnsileImg21_PAC_S1Img1, turnsileImg21_PAC_S1Img2, turnsileImg21_PAC_S1Img3],
      code: 'PAC-S1',
      price1: '490.000',
      price2: '784.000',
   },
   {
      id: '1',
      img: [turnsileImg1],
      code: 'PZ-1',
      price1: '490.000',
      price2: '784.000',
   },

   {
      id: '2',
      img: [turnsileImg2],
      code: 'PZ-2',
      price1: '490.000',
      price2: '784.000',
   },

   {
      id: '3',
      img: [turnsileImg3, pz3Img2, pz3Img3],
      code: 'PZ-3',
      price1: '490.000',
      price2: '784.000',
   },

   {
      id: '4',
      img: [turnsileImg4],
      code: 'PZ-4',
      price1: '490.000',
      price2: '784.000',
   },

   {
      id: '5',
      img: [turnsileImg5],
      code: 'PZ-5',
      price1: '490.000',
      price2: '784.000',
   },

   {
      id: '6',
      img: [turnsileImg6],
      code: 'PZ-6',
      price1: '435.000',
      price2: '696.000',
   },

   {
      id: '7',
      img: [turnsileImg7],
      code: 'PZ-7',
      price1: '435.000',
      price2: '696.000',
   },

   {
      id: '8',
      img: [turnsileImg8],
      code: 'PZ-8',
      price1: '435.000',
      price2: '696.000',
   },

   {
      id: '9',
      img: [turnsileImg9],
      code: 'PZ-9',
      price1: '435.000',
      price2: '696.000',
   },


   {
      id: '10',
      img: [turnsileImg10],
      code: 'PZ-10',
      price1: '435.000',
      price2: '696.000',
   },

   {
      id: '11',
      img: [turnsileImg11],
      code: 'PZ-11',
      price1: '435.000',
      price2: '696.000',
   },

   {
      id: '12',
      img: [turnsileImg12],
      code: 'PZ-12',
      price1: '435.000',
      price2: '696.000',
   },

   {
      id: '13',
      img: [turnsileImg13],
      code: 'PZ-13',
      price1: '290.000',
      price2: '',
   },

   {
      id: '14',
      img: [turnsileImg14],
      code: 'PZ-14',
      price1: '390.000',
      price2: '450.000',
   },

   {
      id: '15',
      img: [turnsileImg15],
      code: 'PZ-15',
      price1: '390.000',
      price2: '450.000',
   },

   {
      id: '16',
      img: [turnsileImg16],
      code: 'PZ-16',
      price1: '435.000',
      price2: '696.000',
   },

   {
      id: '17',
      img: [turnsileImg20],
      code: 'PZ-20',
      price1: '435.000',
      price2: '696.000',
   },

   {
      id: '18',
      img: [turnsileImg18],
      code: 'PZ-18',
      price1: '',
      price2: '',
   },

   {
      id: '19',
      img: [turnsileImg19],
      code: 'PZ-19',
      price1: '200000',
      price2: '',
   },

   {
      id: '20',
      img: [turnsileImg17],
      code: 'PZ-17',
      price1: '200000',
      price2: '',
   },
]

export const turnstileVideosData = [
   {
      id: '1',
      video: 'https://www.youtube.com/watch?v=px_KGl8500Y',
      title: 'Սուպերմարկետների համար նախատեսված տուրնիկետ'
   },

   {
      id: '2',
      video: 'https://www.youtube.com/watch?v=lUzoVbEifyI',
      title: 'Գրասենյակների համար նախատեսված տուռնիկետ'
   },

   {
      id: '3',
      video: 'https://www.youtube.com/shorts/qIpvQ2NfKG4',
      title: 'Բացօդյա Տուռնիկետ՝ Դեմքի Ճանաչմամբ․ Ապահով և Խելացի Մուտքի Վերահսկման Համակարգ'
   },

   {
      id: '4',
      video: 'https://www.youtube.com/watch?v=2h6m9jsOMKg',
      title: 'Տուռնիկետների Վաճառք․ Ձեր Ընկերության Ապահովության և Կառավարման Լավագույն Լուծումները'
   },

   {
      id: '5',
      video: 'https://www.youtube.com/shorts/fLCiFFd-lwY',
      title: 'Աշխատակիցների վերահսկման սարքավորում դեմքի ճանաչման, QR սկանավորման հնարավորությամբ'
   },

   {
      id: '6',
      video: 'https://youtube.com/shorts/jUjcHnsi_lM?feature=shared',
      title: 'Տոմսային միասնական համակարգի QR տոմսով մուտքի դեմոնստրացիա'
   },
]




export const turnstileDataHome = [
   {
      id: '1',
      img: [turnsileImg1],
      code: 'PZ-1',
      price1: '490.000',
      price2: '784.000',
   },

   {
      id: '2',
      img: [turnsileImg2],
      code: 'PZ-2',
      price1: '490.000',
      price2: '784.000',
   },

   {
      id: '3',
      img: [turnsileImg3],
      code: 'PZ-3',
      price1: '490.000',
      price2: '784.000',
   },
]



// ============webProjectPaheservicesData==========================

export const web_project_services_data = [
   {
      id: '1',
      name: 'HTML 5',
      img: webProject_services_html
   },

   {
      id: '2',
      name: 'CSS 3',
      img: webProject_services_css
   },

   {
      id: '3',
      name: 'Bootstrap',
      img: webProject_services_bootstrap
   },


   {
      id: '4',
      name: 'JavaScript',
      img: webProject_services_javascript
   },

   {
      id: '5',
      name: 'JQuery',
      img: webProject_services_jquery
   },

   {
      id: '6',
      name: 'Laravel',
      img: webProject_services_laravel
   },

   {
      id: '7',
      name: 'Ajax',
      img: webProject_services_ajax
   },

   {
      id: '8',
      name: 'React',
      img: webProject_services_react
   },

   {
      id: '9',
      name: 'PHP',
      img: webProject_services_php
   },

   {
      id: '10',
      name: 'MySQL',
      img: webProject_services_mysql
   },

   {
      id: '11',
      name: 'Python',
      img: webProject_services_pyton
   },

   {
      id: '12',
      name: 'Node JS',
      img: webProject_services_nodejs
   },
]



export const mobile_page_services_data = [
   {
      id: '1',
      name: 'Swift',
      img: mobailAppDevelopend_services_swift
   },

   {
      id: '2',
      name: 'Java/Java8',
      img: mobailAppDevelopend_services_java
   },

   {
      id: '3',
      name: 'Databases',
      img: mobailAppDevelopend_services_dataBases
   },


   {
      id: '4',
      name: 'APIs',
      img: mobailAppDevelopend_services_apis
   },

   {
      id: '5',
      name: 'JQuery',
      img: mobailAppDevelopend_services_j_query
   },

   {
      id: '6',
      name: 'Android SDK',
      img: mobailAppDevelopend_services_android
   },

   {
      id: '7',
      name: 'Design guidelines',
      img: mobailAppDevelopend_services_design
   },

   {
      id: '8',
      name: 'Python',
      img: mobailAppDevelopend_services_python
   },

]


export const modelinp3DPageServicesData = [
   {
      id: '1',
      name: 'Blender',
      img: blenderImg
   },

   {
      id: '2',
      name: 'Material',
      img: materialImg
   },

   {
      id: '3',
      name: 'Gimp, C#',
      img: gimpImg
   },

   {
      id: '4',
      name: 'MakeHuman',
      img: makeHumanImg
   }
]

export const gamesPageServicesData = [
   {
      id: '1',
      name: 'Blender',
      img: blenderImg
   },

   {
      id: '2',
      name: 'Substance',
      img: gamesPagesServicesImgSubstance
   },

   {
      id: '3',
      name: 'Gimp, C#',
      img: gimpImg
   },

   {
      id: '4',
      name: 'Unity 3D',
      img: gamesPagesServicesImgUnity
   }
]